import network from '@/services/network';

/**
 * Antragstypen (BER-67). `active` liefert die aktiven Typen für den
 * Antrags-Wizard (jeder eingeloggte User); die übrigen Endpunkte sind die
 * Admin-Verwaltung (nur `application-types.manage`).
 */
export interface ApplicationType {
  id: number;
  value: string;
  label: string;
  position: number;
  is_active: boolean;
  /** Ob dieser Typ eine IDD (Geeignetheitsprüfung) erfordert. */
  requires_idd: boolean;
  updated_at?: string;
}

export interface ApplicationTypeInput {
  value: string;
  label: string;
  position?: number;
  is_active?: boolean;
  requires_idd?: boolean;
}

const getActive = async (): Promise<ApplicationType[]> => {
  const { data } = await network.get<{ data: ApplicationType[] }>('/application-types/active');
  return data.data;
};

const getAll = async (): Promise<ApplicationType[]> => {
  const { data } = await network.get<{ data: ApplicationType[] }>('/application-types');
  return data.data;
};

const create = async (input: ApplicationTypeInput): Promise<ApplicationType> => {
  const { data } = await network.post<{ data: ApplicationType }>('/application-types', input);
  return data.data;
};

const update = async (
  id: number,
  input: Partial<ApplicationTypeInput>,
): Promise<ApplicationType> => {
  const { data } = await network.put<{ data: ApplicationType }>(`/application-types/${id}`, input);
  return data.data;
};

const remove = async (id: number): Promise<void> => {
  await network.delete(`/application-types/${id}`);
};

const applicationType = { getActive, getAll, create, update, remove };

export default applicationType;
